import { Component, Input } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../_models/ITranslations";
import { TranslationService } from "../_services/translation.service";
import { DevToolsService } from "../_services/dev-tools.service";

@Component({
  selector: "development-component",
  templateUrl: "development.component.html",

  styleUrls: ["development.component.scss"],
})
export class DevelopmentComponent {
  public translations$: Observable<ITranslations>;
  public devToolsOn: boolean = false;

  constructor(
    private translationService: TranslationService,
    private devToolsService: DevToolsService
  ) {
    this.devToolsOn = this.devToolsService.devToolsEnabled;
    this.translations$ = this.translationService.translations;
  }
  public handleClickDevTools(action: "on" | "off") {
    this.devToolsOn = action === "on";
    this.devToolsService.setDevToolsEnabled(this.devToolsOn);
  }
}



// WEBPACK FOOTER //
// ./src/app/development/development.component.ts